import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  data: () => ({
    
  }),
  computed: {
    active_solution() {
      if (this.solutionID && this.allSolutions) {
        return this.allSolutions.find((o) => o.id == Number(this.solutionID));
      }
    },
    active_solution_settings() {
      if (this.active_solution) {
        return this.active_solution.settings
      }
    },
    ...mapState({
      solutionID: (state) => state.Solution.solutionID,
      allSolutions: (state) => state.Solution.allSolutions,
      // data: state=> state.Module.state_var
    }),
  },
};